export default {
  subscribedJobId: null,
  jobActivitiesSubscribed: false,
}
